import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NoAuthGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean {
    const token = sessionStorage.getItem('token');
    const usuario = sessionStorage.getItem('usuario');

    if (token && usuario) {
      this.router.navigateByUrl('/salon', { replaceUrl: true });
      return false;
    }

    if (token && !usuario) {
      sessionStorage.clear();
    }

    return true;
  }
}
